<script setup lang="ts">
import type { NovaHeaderLeftSideProps } from './NovaHeaderLeftSide.types'

withDefaults(defineProps<NovaHeaderLeftSideProps>(), {
  scroll: false,
})
</script>

<template>
  <aside :class="['left-side-bar', { scroll }]">
    <div class="inner">
      <slot />
    </div>
  </aside>
</template>

<style lang="scss" scoped>
.left-side-bar {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
  width: 100%;
  height: 100%;
  padding-top: $main-vertical-padding;
  padding-bottom: $main-vertical-padding;

  &.scroll {
    overflow-y: overlay;

    > .inner {
      height: auto;
    }
  }

  > .inner {
    height: 100%;
  }
}
</style>
